import { Injectable } from '@angular/core';
//import { Router } from '@angular/router';
import { IApiService } from './iapi.service';
import { UtilService } from '../util/util.service';
import { AuthService } from '../auth/auth.service';
//import { DialogService } from '../dialog/dialog.service';
//import { NotificationService } from '../notification/notification.service';
import { LogService } from '../log/log.service';
import { Error } from '../model/error.model';
import { HttpRequestService } from '../http/http-request.service';
import { HttpRequestOptions } from '../http/http-request-options.model';
import { ApiCacheOptions } from './api-cache-options.model';
import { EnvironmentService } from '../environment/environment.service';
import { EnvironmentConfig } from '../environment/environment-config.model';
import { NameValue } from '../model/name-value.model';

//import { TranslateService } from 'ng2-translate';
import { Observable, throwError } from 'rxjs';
import { NotificationService } from '../notification/notification.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiService implements IApiService {
  private _headers: Array<NameValue>;
  private _utilService: UtilService;
  private _authService: AuthService;
  protected _apiBaseUrl: string = '';
  protected _apiDomain: string = '';
  private _requestedUrl: string = '';
  //private _dialogService: DialogService;
  //private _notifyService: NotificationService;
  //private _translateService: TranslateService;
  private _logService: LogService;
  private _apiUrlsSet: boolean;
  private _requestData: any;
  private _httpRequestService: HttpRequestService;
  //private _router: Router;
  private _environmentService: EnvironmentService;

  public constructor(
    authService: AuthService,
    utilService: UtilService,
    logService: LogService,
    httpRequestService: HttpRequestService,
    environmentService: EnvironmentService,
    private _notificationService: NotificationService
  ) {
    this._utilService = utilService;
    this._authService = authService;
    //this._dialogService = dialogService;
    //this._notifyService = notifyService;
    this._requestedUrl = '';
    //this._translateService = translateService;
    this._logService = logService;
    this._httpRequestService = httpRequestService;
    //this._router = router;
    this._environmentService = environmentService;

    this._headers = new Array<NameValue>();
    this._apiUrlsSet = false;
    this._requestData = null;

    this._apiBaseUrl = '';
    this._apiDomain = '';

    this.ensureApiUrlsAreSet();
  }

  public ensureApiUrlsAreSet = (): Promise<boolean> => {
    if (this._utilService.isNotNullEmptyOrWhitespace(this._apiDomain) && this._utilService.isNotNullEmptyOrWhitespace(this._apiBaseUrl)) {
      return Promise.resolve(true);
    } else {
      //check for dev environment
      let environmentConfig: EnvironmentConfig = this._environmentService.getEnvironmentConfig();
      let apiBaseUrl: string = environment['WebApiUrl'];
      if (apiBaseUrl != null) {
        this._apiDomain = apiBaseUrl;
        this._apiBaseUrl = this._apiDomain + '/api';
        this._apiUrlsSet = true;
        return Promise.resolve(true);
      } else if (environmentConfig.WebApiIsSingleInstance == true) {
        this._logService.log('Web Api', 'Web Api is single instance');
        this._apiDomain = environmentConfig.WebApiUrl;
        this._apiBaseUrl = this._apiDomain + '/api';
        this._apiUrlsSet = true;
        this._logService.log('Web Api', 'url ' + this._apiBaseUrl);
        return Promise.resolve(true);
      } else {
        if (
          this._utilService.containsAnyCase(window.location.host, 'localhost') ||
          this._utilService.containsAnyCase(window.location.hostname, 'artemis')
        ) {
          this._apiDomain = 'https://localhost.weblinkconnect.com';
          this._apiBaseUrl = this._apiDomain + '/api';
          this._apiUrlsSet = true;
          return Promise.resolve(true);
        } else {
          return this._authService.getUserInfo().then((data: any) => {
            this._apiDomain = data.wli_tenant_https_url;
            if (this._utilService.endswith(this._apiDomain, '/') == true) {
              if (this._apiDomain.length > 1) {
                //drop any trailing /
                this._apiDomain = this._utilService.left(this._apiDomain, this._apiDomain.length - 1);
              }
            }
            this._apiBaseUrl = this._apiDomain + '/api'; //"https://" + this._authService.getTenant() + ".weblinkconnect.com/api";
            this._apiUrlsSet = true;
            return Promise.resolve(true);
          });
        }
      }
    }
  };

  public getBaseUrl = (): string => {
    this.ensureApiUrlsAreSet();
    return this._apiBaseUrl;
  };

  public getDomain = (): string => {
    this.ensureApiUrlsAreSet();
    return this._apiDomain;
  };

  public getDomainAsync(): Promise<string> {
    return this.ensureApiUrlsAreSet().then((areSet) => {
      return this._apiDomain;
    });
  }

  public getServiceBaseUrl(serviceName: string) {
    let apiBaseUrl: string = environment[`${serviceName}ServiceApiBase`];
    if (apiBaseUrl?.length) {
      let port = environment[`${serviceName}ServicePort`];
      let apiDomain = `${apiBaseUrl}${port}`;
      return `${apiDomain}/api`;
    }

    return '';
  }

  public get(url: string, cacheOptions?: ApiCacheOptions, notifyOnError?: boolean): Promise<any> {
    if (this._utilService.isNullOrUndefined(cacheOptions)) {
      cacheOptions = this.getDefaultApiCacheOptionsForFrequentlyChangedData();
    }

    return this.getFullUrl(url)
      .then((resultUrl: string) => {
        let fullUrl = resultUrl;

        if (this.ensureValidAccessToken(fullUrl)) {
          let httpRequestOptions: HttpRequestOptions = this.getHttpRequestOptionsFromApiCacheOptions(cacheOptions);

          return this._httpRequestService.getRequest(fullUrl, httpRequestOptions);
        } else {
          //empty promise
          return this._httpRequestService.get(fullUrl);
        }
      })
      .catch((error) => {
        if (notifyOnError) {
          this._notificationService.httpError(error);
        }
        throw error;
      });
  }

  public getObservable = (url: string, cacheOptions?: ApiCacheOptions): Promise<Observable<any>> => {
    if (this._utilService.isNullOrUndefined(cacheOptions)) {
      cacheOptions = this.getDefaultApiCacheOptionsForFrequentlyChangedData();
    }

    return this.getFullUrl(url).then((data: string) => {
      let fullUrl = data;

      if (this.ensureValidAccessToken(fullUrl)) {
        let httpRequestOptions: HttpRequestOptions = this.getHttpRequestOptionsFromApiCacheOptions(cacheOptions);

        Promise.resolve(this._httpRequestService.getObservable(fullUrl, httpRequestOptions));
      } else {
        //empty promise
        return throwError(null);
      }
    });
  };

  public post = (url: string, data: any, notifyOnError?: boolean): Promise<any> => {
    return this.getFullUrl(url)
      .then((resultUrl: string) => {
        let fullUrl = resultUrl;

        if (this.ensureValidAccessToken(fullUrl)) {
          let body: any = null;
          if (this._utilService.isNotNullOrUndefined(data)) {
            body = JSON.stringify(data);
          } else {
            body = '';
          }
          let requestOptions = this.getHttpRequestOptionsForWriteOperations();
          return this._httpRequestService.post(fullUrl, body, requestOptions);
        } else {
          //empty promise
          return Promise.resolve();
        }
      })
      .catch((error) => {
        if (notifyOnError) {
          this._notificationService.httpError(error);
        }
        throw error;
      });
  };

  public async postRaw(url: string, data: object | FormData): Promise<any> {
    const resultUrl = await this.getFullUrl(url);
    return this._httpRequestService.post(resultUrl, data);
  }

  public async postRawTextReturn(url: string, data: object | FormData): Promise<any> {
    const resultUrl = await this.getFullUrl(url);
    return this._httpRequestService.postTextReturn(resultUrl, data);
  }

  public put = (url: string, data: any, notifyOnError?: boolean): Promise<any> => {
    return this.getFullUrl(url)
      .then((resultUrl: string) => {
        let fullUrl = resultUrl;

        if (this.ensureValidAccessToken(fullUrl)) {
          let body: any = null;
          if (this._utilService.isNotNullOrUndefined(data)) {
            body = JSON.stringify(data);
          } else {
            body = '';
          }
          let requestOptions = this.getHttpRequestOptionsForWriteOperations();
          return this._httpRequestService.put(fullUrl, body, requestOptions);
        } else {
          //empty promise
          return Promise.resolve();
        }
      })
      .catch((error) => {
        if (notifyOnError) {
          this._notificationService.httpError(error);
        }
        throw error;
      });
  };

  public async putRaw(url: string, data: object | FormData): Promise<any> {
    const resultUrl = await this.getFullUrl(url);
    return this._httpRequestService.put(resultUrl, data).catch((error) => {});
  }

  public delete = (url: string, notifyOnError?: boolean): Promise<any> => {
    return this.getFullUrl(url)
      .then((data: string) => {
        let fullUrl = data;

        if (this.ensureValidAccessToken(fullUrl)) {
          let requestOptions = this.getHttpRequestOptionsForWriteOperations();
          return this._httpRequestService.delete(fullUrl, requestOptions);
        } else {
          //empty promise
          return Promise.resolve();
        }
      })
      .catch((error) => {
        if (notifyOnError) {
          this._notificationService.httpError(error);
        }
        throw error;
      });
  };

  public deleteData = (url: string, data: any): Promise<any> => {
    return this.getFullUrl(url).then((resultUrl: string) => {
      let fullUrl = resultUrl;

      if (this.ensureValidAccessToken(fullUrl)) {
        //this._requestOptions.body = data;
        let requestOptions = this.getHttpRequestOptionsForWriteOperations();
        return this._httpRequestService.deleteData(fullUrl, data, requestOptions);
      } else {
        //empty promise
        return Promise.resolve();
      }
    });
  };

  public getPaged = (urlBase: string, params: any, cacheOptions?: ApiCacheOptions, notifyOnError?: boolean): Promise<any> => {
    if (this._utilService.isNullOrUndefined(cacheOptions)) {
      cacheOptions = this.getDefaultApiCacheOptionsForFrequentlyChangedData();
    }
    return this.getFullUrl(urlBase)
      .then((resultUrl: string) => {
        let fullUrl = resultUrl;

        if (this.ensureValidAccessToken(fullUrl)) {
          let paramNames: any = Object.getOwnPropertyNames(params);
          for (let pagedParamIndex: number = 0; pagedParamIndex < paramNames.length; pagedParamIndex++) {
            var paramName = paramNames[pagedParamIndex];
            var paramValue = params[paramName];
            if (this._utilService.isNotNullOrUndefined(paramValue)) {
              if (params[paramName] instanceof Date) {
                paramValue = this._utilService.getShortDateString(paramValue);
              }
              if (this._utilService.toLowerTrim(paramName) == 'orderby' && this._utilService.isNullEmptyOrWhitespace(paramValue)) {
                //ignore the order by as its not supplied
              } else {
                if (!this._utilService.containsAnyCase(fullUrl, '?')) {
                  fullUrl += '?';
                } else {
                  fullUrl += '&';
                }

                fullUrl += encodeURIComponent(paramName) + '=' + encodeURIComponent(paramValue);
              }
            }
          }

          //if we didn't add any params to qs then just set as base url
          if (fullUrl == '') {
            fullUrl = urlBase;
          }

          return this.get(fullUrl, cacheOptions);
        } else {
          //empty promise
          return Promise.resolve();
        }
      })
      .catch((error) => {
        if (notifyOnError) {
          this._notificationService.httpError(error);
        }
        throw error;
      });
  };

  public postPaged = (urlBase: string, params: any): Promise<any> => {
    return this.getFullUrl(urlBase)
      .then((data: string) => {
        let fullUrl = data;

        if (this.ensureValidAccessToken(fullUrl)) {
          //validate expected paged param properties
          if (this._utilService.isNullOrUndefined(params.TotalCount)) {
            params.TotalCount = 0;
          }
          if (this._utilService.isNullOrUndefined(params.TotalPages)) {
            params.TotalPages = 1;
          }
          if (this._utilService.isNullOrUndefined(params.PageNumber)) {
            params.PageNumber = 1;
          }
          if (this._utilService.isNullOrUndefined(params.PageSize)) {
            params.PageSize = 20;
          }

          return this.post(fullUrl, params);
        } else {
          //empty promise
          return Promise.resolve();
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  public getFile(url: string): Promise<Blob> {
    //let fullUrl = this.getFullUrlValue(url);
    return this.getFullUrl(url).then((fullUrl: string) => {
      var options = this.getHttpRequestOptionsForWriteOperations();
      return this._httpRequestService
        .getFile(fullUrl, options)
        .toPromise()
        .catch((error) => {
          throw error;
        });
    });
  }

  public postFile(url: string, formData: FormData): Promise<void> {
    //let fullUrl = this.getFullUrlValue(url);
    return this.getFullUrl(url)
      .then((fullUrl: string) => {
        var options = this.getHttpRequestOptionsForWriteOperations();
        return this._httpRequestService.post(fullUrl, formData, options);
      })
      .catch((error) => {
        throw error;
      });
  }

  //public getHttpResponseObservableAsPromise(observable: Observable<any>): Promise<any> {

  //  return observable.toPromise().then(
  //    (res: Response) => {

  //      let data = this.extractData(res);
  //      return Promise.resolve(data)
  //    },
  //    (errRes: Response) => {

  //      let err = this.extractError(errRes);
  //      return Promise.reject(err);

  //    });
  //}

  //public extractData = (res: Response) => {

  //  let data: any = null;
  //  if (res.status == 204) {
  //    //this is a no content response A VOID
  //    this._logService.log('api returned no data', "");
  //  } else {
  //    data = res.json();
  //    //this._utilService.convertJsonDateStringsToDates(data)
  //    this._utilService.convertJsonUtcServerDateStringsToDates(data);
  //    this._logService.log('api returned data from ' + this._requestedUrl, data);
  //  }

  //  return data; //body.data || {};
  //}

  //public extractError = (error: Response): Error => {

  //  let err = new Error();
  //  err.Message = "Server error.";

  //  if (error.status) {
  //    if (error.status == 401) {

  //      this._router.navigate(["/unauthenticated"]);

  //    }

  //  }

  //  err = error.json();

  //  if (this._utilService.isNotNullOrUndefined(err.Message)) {
  //    this._notifyService.error(err.Message);
  //  } else if (this._utilService.isNotNullOrUndefined(err.ExceptionMessage)) {
  //    this._notifyService.error(err.ExceptionMessage);
  //  } else {
  //    this._notifyService.error(err.toString());
  //  }

  //  return err;

  //}

  //public handleObservableError = (error: Response): Observable<any> => {

  //  return Observable.throw(error);
  //}
  ////public handleError = (error: Response): Observable<any> => {

  ////    let err = new ApiError
  ////    err.Message = "Server error.";

  ////    if (error.status) {
  ////        if (error.status == 401) {

  ////            this._authService.sendUserToUnauthenticatedComponent();

  ////        }

  ////    }

  ////    err = error.json();

  ////    if (this._requestedUrl) {

  ////        err.ExceptionMessage = err.ExceptionMessage + "  Requested url " + this._requestedUrl + ".";

  ////    }

  ////    if (this.disableErrorHandling == false) {
  ////        this._dialogService.error(err.Message);
  ////    }

  ////    this._logService.error(err.ExceptionMessage);

  ////    return Observable.throw(new Error(err.ExceptionMessage))

  ////}

  public isApiRouteAnnon = (url: string): boolean => {
    let result: boolean = false;

    if (this._utilService.containsAnyCase(url.trim(), 'api/users/requestpasswordreset')) {
      result = true;
    }
    if (this._utilService.containsAnyCase(url.trim(), 'api/users/passwordreset')) {
      result = true;
    }
    if (this._utilService.containsAnyCase(url.trim(), 'api/test/')) {
      result = true;
    }

    return result;
  };

  public hasValidAccessToken = (url: string): boolean => {
    let isValid = false;

    this._headers = new Array<NameValue>();
    this._headers.push(new NameValue('Content-Type', 'application/json'));

    if (this.isApiRouteAnnon(url)) {
      this._headers.push(new NameValue('Authorization', ''));
      isValid = true;
    } else {
      if (this._authService.currentUserIsAuthenticated() == true) {
        //access token is still good
        let accesToken: string = this._authService.getAccessToken();
        let tenant: string = this._authService.getTenant();

        this._headers.push(new NameValue('Authorization', 'Bearer ' + accesToken));
        if (this._utilService.isNotNullEmptyOrWhitespace(tenant)) {
          this._headers.push(new NameValue('x-tenant', tenant));
        }

        isValid = true;
      } else {
        //force user to re login

        isValid = false;
      }
    }

    ////https://github.com/angular/angular/issues/10612
    //this._requestOptions = new RequestOptions({
    //  body: '', //if this isn't set in rc5 it will break
    //  headers: this._headers
    //});

    return isValid;
  };
  public ensureValidAccessToken = (url: string): boolean => {
    let valid = this.hasValidAccessToken(url);
    if (valid == false) {
      this._logService.log('api requires authentication', this._requestedUrl);
      //TODO have an event raised that says unauthenticated and have a component subscribe to it????
      //this._router.navigate(["/unauthenticated"]);
    }
    return valid;
  };

  public getFullUrl = (url: string): Promise<string> => {
    return this.ensureApiUrlsAreSet().then((data: boolean) => {
      let fullUrl = url;
      if (this._utilService.startswith(url.toLowerCase(), '/')) {
        //assume rel path starting with /
        fullUrl = this._apiBaseUrl + url;
      } else {
        if (!this._utilService.startswith(url.toLowerCase(), 'http')) {
          //assume rel path starting with no leading /
          fullUrl = this._apiBaseUrl + '/' + url;
        }
      }
      this._requestedUrl = fullUrl;
      //this._logService.log('api url', fullUrl);
      return Promise.resolve(fullUrl);
    });
  };

  public getFullUrlValue = (url: string): string => {
    let fullUrl = url;
    if (this._utilService.startswith(url.toLowerCase(), '/')) {
      //assume rel path starting with /
      fullUrl = this._apiBaseUrl + url;
    } else {
      if (!this._utilService.startswith(url.toLowerCase(), 'http')) {
        //assume rel path starting with no leading /
        fullUrl = this._apiBaseUrl + '/' + url;
      }
    }
    return fullUrl;
  };

  public getDefaultApiCacheOptionsForFrequentlyChangedData = (): ApiCacheOptions => {
    //sliding cache for 30 seconds
    let cacheOptions = new ApiCacheOptions();
    cacheOptions.DisableCaching = false;
    cacheOptions.DeleteCache = false;
    cacheOptions.CacheSeconds = this._httpRequestService.getDefaultCacheSeconds();
    cacheOptions.DisableSlidingCache = false;
    return cacheOptions;
  };

  public getDefaultApiCacheOptionsForInfrequentlyChangedData = (): ApiCacheOptions => {
    //no sliding cache held for 1 day
    let cacheOptions = new ApiCacheOptions();
    cacheOptions.DisableCaching = false;
    cacheOptions.DeleteCache = false;
    cacheOptions.CacheSeconds = 60 * 60 * 24; //1 day
    cacheOptions.DisableSlidingCache = true;
    return cacheOptions;
  };

  public getDefaultApiCacheOptionsForNoCache() {
    const cacheOptions = new ApiCacheOptions();
    cacheOptions.CacheSeconds = 0;
    cacheOptions.DeleteCache = true;
    cacheOptions.DisableCaching = true;
    cacheOptions.DisableSlidingCache = true;
    return cacheOptions;
  }

  public deleteCache = (url: string): void => {
    let fullUrl: string = url;
    if (this._utilService.startswith(url.toLowerCase(), '/')) {
      //assume rel path starting with /
      fullUrl = this._apiBaseUrl + url;
    }
    this._httpRequestService.deleteCache(fullUrl);
  };

  public deleteCacheContains = (urlContains: string): void => {
    this._httpRequestService.deleteCacheContains(urlContains);
  };

  private getHttpRequestOptionsForWriteOperations = (): HttpRequestOptions => {
    let httpRequestOptions = new HttpRequestOptions();
    httpRequestOptions.Headers = this._headers;
    httpRequestOptions.EnableCaching = false;
    httpRequestOptions.CacheSeconds = 0;
    httpRequestOptions.SlidingCache = false;
    httpRequestOptions.SlidingCacheSeconds = 0;

    return httpRequestOptions;
  };

  private getHttpRequestOptionsFromApiCacheOptions = (apiCacheOptions: ApiCacheOptions): HttpRequestOptions => {
    let httpRequestOptions = new HttpRequestOptions();
    httpRequestOptions.Headers = this._headers;
    httpRequestOptions.EnableCaching = !apiCacheOptions.DisableCaching;
    httpRequestOptions.CacheSeconds = apiCacheOptions.CacheSeconds;
    if (apiCacheOptions.DisableSlidingCache == true) {
      httpRequestOptions.SlidingCache = false;
      httpRequestOptions.SlidingCacheSeconds = 0;
    } else {
      httpRequestOptions.SlidingCache = true;
      httpRequestOptions.SlidingCacheSeconds = httpRequestOptions.CacheSeconds;
    }

    if (apiCacheOptions.DeleteCache == true) {
      httpRequestOptions.DeleteCache = true;
    }

    return httpRequestOptions;
  };
}
